import { shopManagerApi } from 'configs';
import api from 'configs/api';
import { showNotification } from 'redux/actions/ui';
import {
  getBulkPriceTargetsStart,
  getBulkPriceTargetsSuccess,
  getBulkPriceTargetsFailed,
  validateBulkPriceCsvStart,
  validateBulkPriceCsvSuccess,
  validateBulkPriceCsvFailed,
  startBulkPriceRunStart,
  startBulkPriceRunSuccess,
  startBulkPriceRunFailed,
  getBulkPriceRunStart,
  getBulkPriceRunSuccess,
  getBulkPriceRunFailed,
  exportBulkPriceRunStart,
  exportBulkPriceRunSuccess,
  exportBulkPriceRunFailed
} from 'redux/actions/bulk_price';


const errorMessage = (e) => e?.response?.data?.error || e?.message || 'Something went wrong';

export const getBulkPriceTargetsAPI = async ({ dispatch }) => {
  try {
    dispatch(getBulkPriceTargetsStart());
    const { data } = await api.get(`${shopManagerApi}/bulk-price/targets`);
    dispatch(getBulkPriceTargetsSuccess(data));
  } catch (e) {
    dispatch(getBulkPriceTargetsFailed(e));
    dispatch(showNotification('error', errorMessage(e)));
  }
};

export const validateBulkPriceCsvAPI = async ({ dispatch, rows }) => {
  try {
    dispatch(validateBulkPriceCsvStart());
    const { data } = await api.post(`${shopManagerApi}/bulk-price/validate`, { rows });
    dispatch(validateBulkPriceCsvSuccess(data));

    return data;
  } catch (e) {
    dispatch(validateBulkPriceCsvFailed(e));
    dispatch(showNotification('error', errorMessage(e)));

    return null;
  }
};

/**
 * Start a run. A preview is the same run with dryRun true, so the preview can never drift from
 * what the real run does - it is the identical code path on both sides.
 */
export const startBulkPriceRunAPI = async ({
  dispatch,
  rows,
  targetIds,
  brand = '',
  reindexAfterEachStore = true,
  dryRun
}) => {
  try {
    dispatch(startBulkPriceRunStart());
    const path = dryRun ? 'preview' : 'run';
    const { data } = await api.post(`${shopManagerApi}/bulk-price/${path}`, {
      rows,
      targetIds,
      brand,
      reindexAfterEachStore
    });
    dispatch(startBulkPriceRunSuccess(data));

    return data;
  } catch (e) {
    dispatch(startBulkPriceRunFailed(e));
    dispatch(showNotification('error', errorMessage(e)));

    return null;
  }
};

export const getBulkPriceRunAPI = async ({ dispatch, runId, page = 1, silent = false }) => {
  try {
    if (!silent) {
      dispatch(getBulkPriceRunStart());
    }

    const { data } = await api.get(`${shopManagerApi}/bulk-price/run/${runId}?page=${page}`);
    dispatch(getBulkPriceRunSuccess(data));

    return data;
  } catch (e) {
    dispatch(getBulkPriceRunFailed(e));

    if (!silent) {
      dispatch(showNotification('error', errorMessage(e)));
    }

    return null;
  }
};

export const exportBulkPriceRunAPI = async ({ dispatch, runId }) => {
  try {
    dispatch(exportBulkPriceRunStart());
    const { data } = await api({
      method: 'get',
      url: `${shopManagerApi}/bulk-price/run/${runId}/export`,
      responseType: 'blob'
    });

    const file = URL.createObjectURL(data);
    window.location.assign(file);

    dispatch(exportBulkPriceRunSuccess());
  } catch (e) {
    dispatch(exportBulkPriceRunFailed(e));
    dispatch(showNotification('error', errorMessage(e)));
  }
};
